/**
 * @module ルーティング設定
 */
import Vue from 'vue';
import VueRouter from 'vue-router';

if (!process || process.env.NODE_ENV !== 'test') {
  Vue.use(VueRouter);
}

const routes = [
  {
    // FE-CU07_TOP画面
    path: '/top',
    name: 'Top',
    component: () => import(/* webpackChunkName: "Top" */ '../pages/top/Index.vue'),
    meta: {
      title: 'トップ',
      requiresAuth: true,
      desc: 'ディスクリプションを記述',
    },
  },
  {
    path: '/',
    redirect: '/login',
  },
  {
    // FE-CU01_ログイン画面
    path: '/login',
    name: 'Login',
    component: () => import('../pages/user/login/Index.vue'),
    meta: {
      title: 'ログイン',
      desc: 'ディスクリプションを記述',
    },
  },
  {
    // FE-CU03_2段階認証画面
    path: '/twoStepAuthentication',
    name: 'OneTimePassword',
    component: () => import('../pages/user/oneTimePassword/Index.vue'),
    meta: {
      title: '二段階認証',
    },
  },
  {
    // FE-CU04_パスワード初期化画面(ユーザーID入力)
    path: '/passwordInitUserIdEntry',
    name: 'PasswordInitUserIdEntry',
    component: () => import('../pages/passwordInitUserIdEntry/Index.vue'),
    meta: {
      title: 'パスワード初期化',
    },
  },
  {
    // FE-CU05_パスワード初期化画面(秘密の質問)
    path: '/changeUserInfoOfPassword/passwordInit/:oneTimeUrlID',
    name: 'PasswordInitSecretQuestion',
    component: () => import('../pages/passwordInitSecretQuestion/Index.vue'),
    meta: {
      title: 'パスワード初期化',
    },
  },
  {
    // FE-CU06_パスワード初期化画面(パスワード再登録)
    path: '/passwordInitReregistration/:oneTimeUrlID',
    name: 'PasswordInitReregistration',
    component: () => import('../pages/passwordInitReregistration/Index.vue'),
    meta: {
      title: 'パスワード初期化',
    },
  },
  {
    // FE-CU08_ホームセキュリティ画面
    path: '/homeSecurity',
    name: 'HomeSecurity',
    component: () => import('../pages/homeSecurity/HomeSecurity.vue'),
    meta: {
      title: 'ホームセキュリティ',
      requiresAuth: true,
    },
  },
  {
    // FE-CU09_対象地区詳細画面
    path: '/displayDistrictDetail',
    name: 'AddressDetail',
    component: () => import('../pages/homeSecurity/AddressDetail.vue'),
    meta: {
      title: '対象地区詳細',
      requiresAuth: true,
    },
  },
  {
    // FE-CU10_ユーザー警備操作画面
    path: '/userSecurityOperation',
    name: 'UserSecurityControl',
    component: () => import('../pages/homeSecurity/securityControl/userSecurityControl/Index.vue'),
    meta: {
      title: 'ユーザー警備操作',
      requiresAuth: true,
    },
  },
  {
    // FE-CU12_警報確認画面
    path: '/alermConfirmation',
    name: 'AlertConfirm',
    component: () => import('../pages/homeSecurity/securityControl/AlertConfirm.vue'),
    meta: {
      title: '警報確認',
      requiresAuth: true,
    },
  },
  {
    // FE-CU13_戸締り確認画面
    path: '/lockConfirmation',
    name: 'LockedConfirm',
    component: () => import('../pages/homeSecurity/securityControl/lockedConfirm/Index.vue'),
    meta: {
      title: '戸締り確認',
      requiresAuth: true,
    },
  },
  {
    // FE-CU14_警報確認画面（センサー）
    path: '/sensorWarningConfirmation',
    name: 'AlertConfirmSensor',
    component: () => import('../pages/homeSecurity/securityControl/alertConfirmSensor/Index.vue'),
    meta: {
      title: '警報確認 (センサー)',
      requiresAuth: true,
    },
  },
  {
    // FE-CU15_戸締り確認（エリア）
    path: '/areaLockConfirmation',
    name: 'LockedConfirmArea',
    component: () => import('../pages/homeSecurity/securityControl/lockedConfirmArea/Index.vue'),
    meta: {
      title: '戸締り確認 (エリア)',
      requiresAuth: true,
    },
  },
  {
    // FE-CU16_かけつけ依頼画面
    path: '/emergencyRequest',
    name: 'RustInquiery',
    component: () => import('../pages/rushInquiry/Index.vue'),
    meta: {
      title: '依頼駆けつけ',
      requiresAuth: true,
    },
  },
  {
    // FE-CU17_通知履歴画面
    path: '/notificationHistory',
    name: 'NotificationHistory',
    component: () => import('../pages/notificationHistory/Index.vue'),
    meta: {
      title: '通知履歴',
      requiresAuth: true,
    },
  },
  {
    // FE-CU18_ALSOKへのお問い合わせ画面
    path: '/contact',
    name: 'AboutContractAndItem',
    component: () => import('../pages/inquiry/aboutContactAndItem/Index.vue'),
    meta: {
      title: 'ALSOKへのお問い合わせ',
      requiresAuth: true,
    },
  },
  {
    // FE-CU19_対象地区設定画面
    path: '/displayDistrictSettings',
    name: 'DisplayAreaSetting',
    component: () => import('../pages/homeSecurity/displayAreaSetting/Index.vue'),
    meta: {
      title: '対象地区設定',
      requiresAuth: true,
    },
  },
  {
    // FE-CU20_ニックネーム設定画面
    path: '/setDisplayDistrictNickname',
    name: 'Nickname',
    component: () => import('../pages/homeSecurity/displayAreaSetting/nickname/Index.vue'),
    meta: {
      title: 'ニックネーム設定',
      requiresAuth: true,
    },
  },
  {
    // FE-CU21_IDカード/キー情報設定画面
    path: '/idCardKeySettings',
    name: 'IdCardKeyInfo',
    component: () => import('../pages/homeSecurity/displayAreaSetting/IdCardKeyInfo.vue'),
    meta: {
      title: 'IDカード/キー情報設定',
      requiresAuth: true,
    },
  },
  {
    // FE-CU22_通知配信設定画面
    path: '/displayDistrictNotificationDeliverySettings',
    name: 'NotificationSettingDisplayArea',
    component: () =>
      import('../pages/homeSecurity/displayAreaSetting/NotificationSettingDisplayArea.vue'),
    meta: {
      title: '通知配信設定',
      requiresAuth: true,
    },
  },
  {
    // FE-CU23_見守り情報配信設定画面
    path: '/watchOverInfoDeliverySettings',
    name: 'WatcherInfo',
    component: () => import('../pages/homeSecurity/displayAreaSetting/WatcherInfo.vue'),
    meta: {
      title: '見守り情報配信設定',
      requiresAuth: true,
    },
  },
  {
    // FE-CU24_機器制御画面
    path: '/equipmentControl',
    name: 'MachineControl',
    component: () => import('../pages/machineControl/Index.vue'),
    meta: {
      title: '機器制御',
      requiresAuth: true,
    },
  },
  {
    // FE-CU25_カメラ画面
    path: '/camera',
    name: 'Camera',
    component: () => import('../pages/camera/Camera.vue'),
    meta: {
      title: 'カメラ',
      requiresAuth: true,
    },
  },
  {
    // FE-CU26_カメラ詳細画面
    path: '/cameraDetail',
    name: 'CameraDetail',
    component: () => import('../pages/camera/CameraDetail.vue'),
    meta: {
      title: 'カメラ詳細',
      requiresAuth: true,
    },
  },
  {
    // FE-CU27_カメラ設定画面
    path: '/cameraSettings',
    name: 'CameraSetting',
    component: () => import('../pages/camera/CameraSetting.vue'),
    meta: {
      title: 'カメラ設定',
      requiresAuth: true,
    },
  },
  {
    // FE-CU28_ニックネーム設定画面(カメラ)
    path: '/setCameraNickname',
    name: 'CameraNickname',
    component: () => import('../pages/camera/cameraSetting/CameraNickname.vue'),
    meta: {
      title: 'ニックネーム設定 (カメラ)',
      requiresAuth: true,
    },
  },
  {
    // FE-CU29_通知配信設定画面（カメラ）
    path: '/cameraNotificationDeliverySettings',
    name: 'CameraNotificationSetting',
    component: () => import('../pages/camera/cameraSetting/CameraNotificationSetting.vue'),
    meta: {
      title: '通知配信設定 (カメラ)',
      requiresAuth: true,
    },
  },
  {
    // FE-CU30_ハウスサポート等お問い合わせ画面
    path: '/contactUsHouseSupport',
    name: 'HouseSupport',
    component: () => import('../pages/houseSupport/Index.vue'),
    meta: {
      title: '健康相談等',
    },
  },
  {
    // FE-CU31_各種設定画面
    path: '/variousSettings',
    name: 'VariousSettings',
    component: () => import('../pages/variousSettings/Index.vue'),
    meta: {
      title: '各種設定',
      requiresAuth: true,
    },
  },
  {
    // FE-CU32_アカウント管理(対象地区)画面
    path: '/displayDistrictAccountManagement',
    name: 'DisplayDistrictAccountManagement',
    component: () => import('../pages/accountManagement/displayDistrict/Index.vue'),
    meta: {
      title: 'アカウント管理 (対象地区)',
      requiresAuth: true,
    },
  },
  {
    // FE-CU33_アカウント管理(カメラ)画面
    path: '/cameraAccountManagement',
    name: 'CameraAccountManagement',
    component: () => import('../pages/accountManagement/camera/Index.vue'),
    meta: {
      title: 'アカウント管理 (カメラ)',
      requiresAuth: true,
    },
  },
  {
    // FE-CU34_アカウント管理(ユーザー情報)画面
    path: '/userInfoAccountManagement',
    name: 'UserInfoAccountManagement',
    component: () => import('../pages/accountManagement/userInfo/Index.vue'),
    meta: {
      title: 'アカウント管理 (ユーザー情報)',
      requiresAuth: true,
    },
  },
  {
    // FE-CU35_ログイン方法設定画面
    path: '/loginSettings',
    name: 'LoginSettings',
    component: () => import('../pages/loginSettings/Index.vue'),
    meta: {
      title: 'ログイン方法設定',
    },
  },
  {
    // FE-CU36_パスコード設定画面
    path: '/passcodeSettings',
    name: 'PasscodeSettings',
    component: () => import('../pages/passcodeSettings/Index.vue'),
    meta: {
      title: 'パスコード設定',
      requiresAuth: true,
      devices: ['MobileApp'],
    },
  },
  {
    // FE-CU37_ユーザー管理画面
    path: '/userManagement',
    name: 'UserManagement',
    component: () => import('../pages/userManagement/Index.vue'),
    meta: {
      title: 'ユーザー管理',
      requiresAuth: true,
    },
    props: true,
  },
  {
    // FE-CU38_サブユーザー権限変更画面
    path: '/subUserAuthorityChange',
    name: 'SubUserAuthorityChange',
    component: () => import('../pages/subUserAuthorityChange/Index.vue'),
    meta: {
      title: 'サブユーザー権限変更',
      requiresAuth: true,
    },
    props: true,
  },
  {
    // FE-CU39_新規サブユーザー登録画面（仮登録）
    path: '/subUserTempRegistration',
    name: 'SubUserTempRegistration',
    component: () => import('../pages/subUserTempRegistration/Index.vue'),
    meta: {
      title: '新規サブユーザー登録',
      requiresAuth: true,
    },
  },
  {
    // FE_CU40 メインユーザー移譲画面
    path: '/mainUserTransfer',
    name: 'MainUserTransfer',
    component: () => import('../pages/mainUserTransfer/Index.vue'),
    meta: {
      title: 'メインユーザー移譲',
      requiresAuth: true,
    },
    props: true,
  },
  {
    // FE_CU41 承認/否認選択画面
    path: '/approvalSelect/:branch/:oneTimeUrlID',
    name: 'ApprovalSelect',
    component: () => import('../pages/approvalSelect/Index.vue'),
    meta: {
      title: '承認/否認選択',
    },
  },
  {
    // FE-CU42_緊急連絡先設定画面
    // FE-CU43_緊急連絡先設定画面-同居家族情報
    // FE-CU44_緊急連絡先設定画面-救急情報
    path: '/emergencyContact',
    name: 'EmergencyContact',
    component: () => import('../pages/emergencyContact/Index.vue'),
    meta: {
      title: '緊急連絡先設定',
      requiresAuth: true,
    },
  },
  {
    // FE-CU45_救急情報設定画面
    path: '/firstAidInfoSettings',
    name: 'FirstAidInfo',
    component: () => import('../pages/firstAidInfo/FirstAidInfo.vue'),
    meta: {
      title: '救急情報設定',
      requiresAuth: true,
    },
  },
  {
    // FE-CU46_サービス追加画面
    path: '/serviceAdd',
    name: 'ServiceAdd',
    component: () => import('../pages/serviceAdd/ServiceAdd.vue'),
    meta: {
      title: 'サービス追加',
      requiresAuth: true,
    },
  },
  {
    // FE-CU47_ユーザー情報変更画面（氏名, 電話番号）
    path: '/changeUserInfoOfPersonalData',
    name: 'UserNameEdit',
    component: () => import('../pages/user/nameEdit/Index.vue'),
    meta: {
      title: 'ユーザー情報変更',
      requiresAuth: true,
    },
  },
  {
    // FE-CU48_ユーザー情報変更画面（メールアドレス）
    path: '/changeUserInfoOfUserId',
    name: 'UserInfoMailAddress',
    component: () => import('../pages/user/mailAddressEdit/Index.vue'),
    meta: {
      title: 'ユーザー情報変更',
      requiresAuth: true,
    },
  },
  {
    // FE-CU49_ユーザー情報変更画面(パスワード)
    path: '/changeUserInfoOfPassword',
    name: 'UserPasswordEdit',
    component: () => import('../pages/user/passwordEdit/Index.vue'),
    meta: {
      title: 'ユーザー情報変更',
      requiresAuth: true,
    },
  },
  {
    // FE-CU50_ユーザー情報変更（秘密の質問）
    path: '/changeUserInfoOfSecretQuestion',
    name: 'SecretQuestionEdit',
    component: () => import('../pages/user/secretQuestionEdit/Index.vue'),
    meta: {
      title: 'ユーザー情報変更',
      requiresAuth: true,
    },
  },
  {
    // FE-CU51_アカウント削除画面
    path: '/accountDelete',
    name: 'UserDelete',
    component: () => import('../pages/user/Delete.vue'),
    meta: {
      title: 'アカウント削除',
      requiresAuth: true,
    },
  },
  {
    // FE-CU52_新規メインユーザー登録画面（仮登録）
    path: '/mainUserTempRegistration',
    name: 'MainUserTempRegistration',
    component: () => import('../pages/user/temporaryRegistration/Index.vue'),
    meta: {
      title: '新規メインユーザー登録',
    },
  },
  {
    // FE-CU53_ユーザー登録画面（本登録）
    path: '/userRegistration/:branch/:oneTimeUrlID',
    name: 'UserRegistration',
    component: () => import('../pages/user/registration/Index.vue'),
    meta: {
      title: 'ユーザー登録', //#29544 FE-CU53_ユーザー登録画面（本登録） タイトル誤り
    },
  },
  {
    // FE-CU54_Thanks画面
    path: '/thanks',
    name: 'Thanks',
    component: () => import('../pages/thanks/Index.vue'),
    meta: {
      title: 'Thanks',
    },
  },
  {
    // FE-CU55_Sorry画面
    path: '/sorry',
    name: 'Sorry',
    component: () => import(/* webpackChunkName: "Sorry" */ '../pages/sorry/Index.vue'),
    meta: {
      title: 'Sorry',
    },
  },
  {
    // FC-CU56_利用規約画面
    path: '/terms',
    name: 'Terms',
    component: () => import('../pages/terms/Index.vue'),
    meta: {
      title: '利用規約',
      requiresAuth: true,
    },
  },
  {
    // FE-CU57_プライバシーポリシー画面
    path: '/privacy',
    name: 'PrivacyPolicy',
    component: () => import('../pages/privacy/Index.vue'),
    meta: {
      title: 'プライバシーポリシー',
      requiresAuth: true,
    },
  },
  {
    // FE-CU58_利用規約・プライバシーポリシー同意画面（メインユーザーの場合）
    path: '/approvalTerms',
    name: 'ApprovalTerms',
    component: () => import('../pages/approvalTerms/ApprovalTerms.vue'),
    meta: {
      title: '利用規約・プライバシーポリシー同意',
    },
  },
  {
    // FE-CU58_利用規約・プライバシーポリシー同意画面（サブユーザーの場合）
    path: '/approvalTerms/:branch/:oneTimeUrlID',
    name: 'ApprovalTerms',
    component: () => import('../pages/approvalTerms/ApprovalTerms.vue'),
    meta: {
      title: '利用規約・プライバシーポリシー同意',
    },
  },
  {
    // FE-CU59_ライセンス
    path: '/license',
    name: 'License',
    component: () => import('../pages/license/Index.vue'),
    meta: {
      title: 'ライセンス',
      requiresAuth: true,
    },
  },
  {
    // FE-CU61_ショートカットアクション画面
    path: '/shortcutAction',
    name: 'shortcutAction',
    component: () => import('../pages/shortcutAction/Index.vue'),
    meta: {
      title: 'ショートカットアクション',
      requiresAuth: true,
    },
  },
  {
    // cameraAuth OAuth認証
    path: '/cameraAuth',
    name: 'CameraAuth',
    component: () => import('../pages/cameraAuth/Index.vue'),
    meta: {
      title: '認証',
    },
  },
  {
    // cameraAuth OAuth認証完了後
    path: '/cameraAuth/:oneTimeUrlID',
    name: 'CameraAuth',
    component: () => import('../pages/cameraAuth/Index.vue'),
    meta: {
      title: '認証',
    },
  },
  {
    // 存在しないページ
    path: '*',
    name: 'Other',
    component: () => import(/* webpackChunkName: "Sorry" */ '../pages/sorry/Index.vue'),
    meta: {
      otherUrlFlag: true,
    },
  },
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.VUE_APP_BASE_URL,
  linkExactActiveClass: 'navigation-active',
  routes,
});

export default router;
